










import { Component, Prop, Vue } from 'vue-property-decorator';
import { AudienceSearchFilter } from '../models/AudienceSearchFilter';
import { Getter, Action } from 'vuex-class';

@Component({})
export default class AudienceSearchToggle extends Vue {
    public ToggleFilterResults: AudienceSearchFilter[] = [];

    @Prop({ default: null })
    private initialSearchFilter!: AudienceSearchFilter;

    @Prop({ default: false })
    private UseCachedIfExists!: boolean;

    private showLastAudiencesType: string = 'LastPublished';
    private isLastSaved: boolean = true;
    @Prop({ default: false })
    private isDisabled!: boolean;

    @Action('setSearchToggleCache', {  namespace: 'manageAudience'  })
    private setSearchToggleCache!: any;

    public update() {
        this.ToggleFilterResults = [];
        this.ToggleFilterResults.push(this.initialSearchFilter);
        this.showLastAudiencesType = this.initialSearchFilter.Value;
        this.isLastSaved = this.showLastAudiencesType === 'LastSaved';
    }

    private updateToggle(lastSaved: boolean): void {
        if (!this.isDisabled) {
            this.isLastSaved = lastSaved;
            if (lastSaved) {
                this.showLastAudiencesType = 'LastSaved';
            } else {
                this.showLastAudiencesType = 'LastPublished';
            }
            const result: AudienceSearchFilter = new AudienceSearchFilter(
                'audienceDetailType',
                'equals',
                this.showLastAudiencesType);
            this.ToggleFilterResults = [result];

            if (this.UseCachedIfExists) {
                this.setSearchToggleCache({ data: result });
            }
            this.$emit('onSearch');
        }
    }

    private mounted() {
        this.ToggleFilterResults.push(this.initialSearchFilter);
        this.showLastAudiencesType = this.initialSearchFilter.Value;
        this.isLastSaved = this.showLastAudiencesType === 'LastSaved';
    }
}
